import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AllowedOsUpdatesReducer, allowedOsUpdateFeatureKey } from './allowed-os-updates.reducer';
import { AllowedOsUpdatesEffects } from './allowed-os-updates.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(allowedOsUpdateFeatureKey, AllowedOsUpdatesReducer),
    EffectsModule.forFeature([AllowedOsUpdatesEffects]),
  ],
  providers: [],
})
export class AllowedOsUpdatesStoreModule {}
